import React from 'react';
export function Results() {
  const results = ['🧠 Claridad mental y foco total', '⚡ Energía estable todo el día', '😊 Humor estable y menos irritabilidad', '🫃 Metabolismo activo y menos antojos'];
  return <section className="bg-primary py-20 text-white" data-id="element-158">
      <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-159">
        <h2 className="font-serif text-3xl md:text-4xl font-bold mb-16 max-w-2xl mx-auto leading-tight" data-id="element-160">
          Lo que cambia cuando duermes profundo de verdad
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-16" data-id="element-161">
          {results.map((result, i) => {
          const [icon, ...textParts] = result.split(' ');
          const text = textParts.join(' ');
          return <div key={i} className="flex flex-col items-center gap-4" data-id="element-162">
                <div className="w-16 h-16 bg-accent/10 text-accent rounded-full flex items-center justify-center text-3xl" data-id="element-163">
                  {icon}
                </div>
                <p className="font-medium text-lg max-w-[180px]" data-id="element-164">{text}</p>
              </div>;
        })}
        </div>

        <div className="inline-block bg-accent text-secondary font-bold text-xl md:text-2xl px-8 py-4 rounded-full shadow-lg" data-id="element-165">
          14 Días | 2 Semanas | 1 Método
        </div>
      </div>
    </section>;
}